import Service from './Service';

export default class TillConnectionService extends Service {
    constructor() {
        super();
        this.baseURL = 'crm/merchant/tillconnection';
    }


}